import { CurrencyItem } from '../../../generated-types';

export interface RecommendedCurrency {
    currency: string;
    name: string;
}

export const defaultRecommendedCurrencies: RecommendedCurrency[] = [
    { currency: 'EUR', name: 'Euro' },
    { currency: 'GBP', name: 'Britiske pund' },
    { currency: 'NOK', name: 'Norske kroner' },
    { currency: 'USD', name: 'Amerikanske dollar' },
];

export const formatCurrencyLabel = (currencyItem: CurrencyItem | undefined): string => {
    if (!currencyItem) return '';

    return `${currencyItem.currency} - ${currencyItem.name}`;
};
